/**
 * Created by synerzip on 08/02/16.
 */
import React from 'react';
import { bindActionCreators } from 'redux';
import * as adminActionCreator from '../../actions/admin';
import * as commonActionCreator from '../../actions/common';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {Input, Modal, Button, FormGroup, FormControl, Table, Row, Col, ControlLabel} from 'react-bootstrap';
import { STATUSES } from '../../constants/other';
import _ from 'lodash';
import SpellCheckInput from '../../components/SpellCheckInput';

class APCMLevelChangeConsentRequiredModal extends React.Component {

    constructor(props){
        super(props);
        const {activeUser, selectedPatient} = props;
        const isRetSpec = activeUser && activeUser.center && activeUser.center.support_flag;
        this.state = {
            declineReason: isRetSpec && selectedPatient.status == 10 ? '30' : '33'
        }
    }

    componentDidMount(){
        if(!this.props.patientServicesReasons){
            this.props.adminActions.getAPCMDeclinedReasons();
        }
        if(!this.props.unenrollReasons){
            this.props.adminActions.getUnenrollReasons();
        }
    }

    onCancel() {
        this.props.onPopupHide();
    }

    reConsent() {
        const {selectedPatient,adminActions,activeUser} = this.props;
        const isRetSpec = activeUser && activeUser.center && activeUser.center.support_flag;
        if(isRetSpec && selectedPatient.status == 10){
            adminActions.apcmLevelChangeApprovedAndActive(selectedPatient.id);
        }else{
            adminActions.apcmLevelChangeApproved(selectedPatient.id);
        }
        this.onCancel();
    }

    sendToSuuport() {
        const {selectedPatient,adminActions,activeUser} = this.props;
        const isRetSpec = activeUser && activeUser.center && activeUser.center.support_flag;
        if(isRetSpec && selectedPatient.status == 10){
            adminActions.supportToPendingUnenroll(selectedPatient.id, this.state.notes, this.state.declineReason, true);
            this.onCancel();
        }else{
            const { messageBody } = this.state;
            adminActions.apcmLevelChangeDecline(selectedPatient.id, this.state.declineReason, messageBody);
            this.onCancel();
        }
        
    }
    onUnenrollReasonChange( e ) {
        let selectedReason = _.find( this.props.unenrollReasons, ( reason ) => reason.id === Number( e.target.value ) );
        if ( selectedReason.id === 6 || selectedReason.id === 23 ) {
            this.setState({ declineReason: selectedReason.id, showNotes: true });
            return;
        }
        this.setState({ declineReason: selectedReason.id, notes: selectedReason.reason, showNotes: false });
    }

    updateNotes( e ) {
		this.setState({ notes: e.target.value });
	}


    render() {
        const {selectedPatient,patientServicesReasons, activeUser,unenrollReasons} = this.props;
        const patientStatus = 10;
        const isRetSpec = activeUser && activeUser.center && activeUser.center.support_flag;
        return (
            <Modal bsSize="large" show={this.props.show}>
                <Modal.Header closeButton onHide={this.onCancel.bind(this)}>
                    <Modal.Title>
                        <div className="text-align-center">
                            <div>APCM Level Change Consent</div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{overflow:'auto',height:'auto'}}>
                        <div style={{padding:15}}>
                            <label>APCM Level Change - Consent Required</label>
                            <div>
                                <label style={{fontWeight:'normal', width:150}}>Current Service Level:</label>
                                <label style={{fontWeight:'normal'}}>{selectedPatient.apcm_service_level}</label>
                            </div>
                             <div>
                                <label style={{fontWeight:'normal', width:150}}>New Eligibile Level:</label>
                                <label style={{fontWeight:'normal'}}>{selectedPatient.apcm_eligible_level}</label>
                            </div>
                            <div style={{display:'flex',flex:1,margin:'15px 0',
                                    justifyContent:'space-evenly',
                                    alignItems:'center'}}>
                                <div style={{display:'flex',
                                flexDirection:'column',
                                justifyContent:'space-between',
                                padding:15,border:'1px solid rgb(232,232,232)',
                                borderRadius:4,
                                height: 400,
                                width: 350}}>
                                    <div>
                                         <label style={{fontWeight:400}}>
                                         Patient has consented to continue in the program at their new level starting next month.
                                        </label>
                                        {patientStatus == 10 && isRetSpec &&
                                            <div>
                                            <ControlLabel><span style={{fontWeight:'normal'}}>The patient's status will updated to</span> Active.</ControlLabel>
                                            </div>
                                        }
                                    </div>
                                   
                                    <Button onClick={this.reConsent.bind(this)} 
                                    className="btn-primary" bsStyle="success">
                                        Confirm Level Change
                                    </Button>
                                </div>
                                <div style={{display:'flex',
                                flexDirection:'column',
                                justifyContent:'space-between',
                                padding:15,border:'1px solid rgb(232,232,232)',
                                borderRadius:4,
                                height: 400,
                                width: 350}}>
                                    <label style={{fontWeight:400}}>
                                        Patient has declined the level change. I have explained that they are not able to continue at their current level.
                                    </label>
                                    {patientStatus == 10 && isRetSpec ? 
                                    <div>
                                        <ControlLabel><span style={{fontWeight:'normal'}}>The patient's status will updated to</span> Pending Unenroll.</ControlLabel> 
                                        <ControlLabel style={{marginTop:15}}>Unenroll Reason</ControlLabel>
                                            <FormControl
                                            componentClass="select"
                                            onChange={this.onUnenrollReasonChange.bind(this)}
                                            placeholder="Please select decline reason"
                                            value={this.state.declineReason}
                                            style={{marginBottom: '10px'}}
                                        >
                                            <option value='' selected disabled>Select an option</option>
                                            {
                                                _.map(unenrollReasons, (reason) => {
                                                   return <option value={reason.id} key={reason.id}>{reason.reason}</option>
                                                })
                                            }
                                            
                                        </FormControl>
                                        { this.state.showNotes ?
                                            <div>
                                                <h5>Internal Notes</h5>
                                                <div>
                                                    <textarea className="form-control" rows="4" value={ this.state.notes } onChange={ this.updateNotes.bind( this ) } maxLength={1024}/>
                                                    <div style={{display:'flex',justifyContent:'flex-end'}}>
                                                        {`${this.state.notes ? this.state.notes.length : 0}/1024`}
                                                    </div>  
                                                </div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>: 
                                    <div>
                                        <ControlLabel>Support Reason</ControlLabel>
                                        <div>
                                            <FormControl
                                            componentClass="select"
                                            value={this.state.declineReason || ''}
                                            onChange={(e) => this.setState({ declineReason: e.target.value })}
                                            placeholder="Please select decline reason"
                                            style={{marginBottom: '10px'}}
                                        >
                                            <option value='' selected disabled>Select an option</option>
                                            {
                                                _.map(patientServicesReasons, (reason) => {
                                                   return <option value={reason.id} key={reason.id}>{reason.reason}</option>
                                                })
                                            }
                                            
                                        </FormControl>
                                        <ControlLabel>Comment</ControlLabel>
                                        <textarea id="modal-message-textarea"
                                                  rows="4"
                                                  value={this.state.messageBody}
                                                  maxLength={1024}
                                                  onChange={(event)=>{ this.setState({messageBody: event.target.value}) }}
                                                  style={{width:"100%"}}/>
                                        </div>
                                        

                                    </div>}
                                    
                                    <Button onClick={this.sendToSuuport.bind(this)} className="btn-primary" bsStyle="danger">
                                        {patientStatus == 10 && isRetSpec ? "Decline Level Change" : "Send to Support"}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div style={{borderTop: '1px solid gray', height: 50, textAlign: 'center', paddingTop: 15}}>
                            <Button id="patientContactCancel" onClick={this.onCancel.bind(this)} style={{float: 'left'}}>
                                Cancel
                            </Button>
                        </div>
                    </div>


                </Modal.Body>

            </Modal>
        );
    }
}
const mapStateToProps = (state) => ({
    selectedPatient: state.app.selectedPatient,
    selectedQueue:state.app.selectedQueue,
    callLogSelections:state.app.callLogSelections,
    callAssistanceTypes:state.app.callAssistanceTypes,
    activeUser: state.admin.activeUser,
    workSummary: state.admin.workSummary,
	associatedCharts: state.levelTwoDashboard.associatedCharts,
    todoLists: state.levelTwoDashboard.todoLists,
    patientServicesReasons: state.admin.patientServicesReasons,
    unenrollReasons: state.admin.unenrollReasons,
});

const mapDispatchToProps = (dispatch) => ({
    adminActions: bindActionCreators(adminActionCreator, dispatch),
    commonActions: bindActionCreators(commonActionCreator, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(APCMLevelChangeConsentRequiredModal);
